import { useMutation } from "@tanstack/react-query";
import { useFormSuccessNotification, useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";

interface UseDeleteShopOverrideRuleParams {
	onSuccess?: () => void;
}

export default function useDeleteShopOverrideRule(
	shopId: string,
	options?: UseDeleteShopOverrideRuleParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();

	const mutation = $api.useMutation("delete", "/shops/{shopId}/override-rules/{ruleId}");

	return useMutation({
		onSuccess: () => {
			successNotification();
			return options?.onSuccess?.();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async (ruleId: string) => {
			return mutation.mutateAsync({
				params: { path: { shopId, ruleId } },
			});
		},
	});
}